import { createFileRoute } from '@tanstack/react-router'

import { SandboxesListPage } from '#features/admin/sandboxes/sandboxes-list-page'

export const Route = createFileRoute('/_app/admin/sandboxes/')({
  component: SandboxesListPage,
})
